<template>
  <Day day="15.12.2025">
    <div slot="page-content">
      <h3>Der erste Versuch 🫣</h3>
      <p>
        <img src="@/assets/day15.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day15',
  components: {
    Day
  }
}
</script>
